import { Box, Button, Container, Typography } from "@mui/material";
import React from "react";
import { Typewriter } from "react-simple-typewriter";
import { mainImg, bg1 } from "../smallComponents/images";
import DownloadIcon from "@mui/icons-material/Download";
import "./HeroSection.css";

const HeroSection = () => {
  return (
    <Box
      sx={{
        backgroundColor: "var(--bg-color)",
        background: `url('${bg1}') no-repeat center center / 100% 100%`,
        py: 10,
      }}
    >
      <Container maxWidth="xl">
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <img src={mainImg} alt="MainImg" height={250} width={200} />
        </Box>
        <Box>
          <Typography
            sx={{
              textAlign: "center",
              textShadow: "0px 0px 13.37690258026123px rgba(0, 0, 0, 0.25)",
              fontFamily: "Roboto",
              fontSize: { xs: "40px", md: "66px" },
              fontStyle: "normal",
              color: "rgb(97, 218, 251)",
              fontWeight: "800",
              lineHeight: "100.5%",
              letterSpacing: "1.92px",
            }}
          >
            Hi! Its me Usman <br /> I'm a
            <Typewriter
              words={[
                " WebDeveloper.",
                " Web Designer.",
                " Programmer.",
                " Frontend Developer.",
                " Backend Developer.",
              ]}
              loop={0}
            />
          </Typography>
          <Typography
            mt={1}
            variant="h6"
            sx={{
              color: "#fafafa",
              textAlign: "center",
              fontWeight: "bold",
              fontFamily: "Oswald",
            }}
          >
            Contact me for work with
            <Typewriter
              words={[" Quality.", " Accuraccy.", " dedication."]}
              loop={0}
            />
          </Typography>
          <Box
            mt={3}
            sx={{
              display: "flex",
              textAlign: "center",
              justifyContent: "center",
              width: "100%",
            }}
          >
            <Button
              variant="contained"
              target="_black"
              href="/usmanCv.pdf"
              sx={{
                position: "relative",
                background: "#263238",
                mb: 1,
                borderRadius: "8px",
                "&:hover": {
                  background: "#263238",
                },
                overflow: "hidden",
                "&::before": {
                  content: '""',
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "200%",
                  height: "200%",
                  background:
                    "linear-gradient(45deg, rgba(255, 255, 255, 0) 25%, rgba(255, 255, 255, 0.3) 50%, rgba(255, 255, 255, 0) 75%)",
                  animation: "moveLight 2s linear infinite",
                },
              }}
            >
              <DownloadIcon sx={{ marginRight: "10px" }} />
              Download CV
            </Button>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default HeroSection;
